import { Button, Icon, TextButton, Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useContactUpdateInquiry } from "../../contactUpdateInquiries/ContactUpdateInquiryProvider";
import { ContactPhoneFormState } from "../../shared/types/contactPhone";
import {
	DrawerFormButtonContainer,
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionItem,
	ViewPageSectionListItem,
} from "../../shared/view";
import { ValueWrapper } from "../../shared/view/ViewComponents";
import { ContactPhoneDrawer } from "./ContactPhoneDrawer";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: phone;
`;

export const ContactViewPhoneNumberSection: FC = () => {
	const { t } = useTranslation();
	const { phoneNumbers, setPhoneNumbers } = useContactUpdateInquiry();

	const emptyContactPhone: ContactPhoneFormState = {
		type: "workLandline",
		phoneNumber: "",
		isPrimary: false,
	};

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Phone numbers")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{phoneNumbers.map((x, index) => (
					<Trigger
						key={x.id}
						render={(props) => (
							<ContactPhoneDrawer
								open={props.open}
								onClose={props.handleClose}
								title={t("Edit phone")}
								initialValues={x}
								onClosed={() => void 0}
								onSubmit={async (values) => {
									setPhoneNumbers((current) =>
										current.map((phoneNumber, innerIndex) =>
											innerIndex === index
												? {
														id: phoneNumber.id,
														phoneNumber: values.phoneNumber,
														type: values.type,
														isPrimary: values.isPrimary,
													}
												: { ...phoneNumber, isPrimary: values.isPrimary ? false : phoneNumber.isPrimary },
										),
									);

									return true;
								}}
							>
								{!x.isPrimary && (
									<DrawerFormButtonContainer>
										<Button
											type="button"
											color="danger"
											onClick={async () => {
												setPhoneNumbers((current) => current.toSpliced(index, 1));
											}}
										>
											{t("Delete phone number")}
										</Button>
									</DrawerFormButtonContainer>
								)}
							</ContactPhoneDrawer>
						)}
					>
						{(props) => (
							<ViewPageSectionListItem {...props}>
								<ValueWrapper>
									<span>{x.phoneNumber}</span>
									{x.isPrimary && <PrimaryLabel />}
								</ValueWrapper>
							</ViewPageSectionListItem>
						)}
					</Trigger>
				))}
				<ViewPageSectionItem>
					<Trigger
						render={(props) => (
							<ContactPhoneDrawer
								open={props.open}
								title={t("Add phone number")}
								onClose={props.handleClose}
								initialValues={emptyContactPhone}
								onClosed={() => void 0}
								onSubmit={async (values) => {
									setPhoneNumbers((current) => [
										...current.map((phoneNumber) => ({
											...phoneNumber,
											isPrimary: values.isPrimary ? false : phoneNumber.isPrimary,
										})),
										{
											id: -1,
											phoneNumber: values.phoneNumber,
											type: values.type,
											isPrimary: values.isPrimary,
										},
									]);

									return true;
								}}
							/>
						)}
					>
						{(props) => (
							<TextButton {...props} color="primary" prefix={<Icon $icon="plus" />}>
								{t("Add phone number")}
							</TextButton>
						)}
					</Trigger>
				</ViewPageSectionItem>
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
